class ToggleButton {
    constructor(
        wrapperSelector,
        btnSelector = '[data-toggle-btn]',
        toggleAreaSelector = '[data-toggle-area]',
        hideOnOutsideClick = false,
        toggleClasses = {expanded: 'toggle-state-expanded', collapsed: 'toggle-state-collapsed'}
    ) {
        if (!wrapperSelector) {
            return;
        }
        this.toggleClasses = toggleClasses;
        this.hideOnOutsideClick = hideOnOutsideClick;

        this.createToggleButtons(wrapperSelector, btnSelector, toggleAreaSelector, toggleClasses, hideOnOutsideClick);
    }

    setupHideOnOutsideClick(toggleButton, toggleArea) {
        const self = this;
        const outsideClickListener = function (event) {
            if (!toggleArea.contains(event.target)) {
                self.collapse(toggleButton, toggleArea);
                document.removeEventListener('click', outsideClickListener);
            }
        };

        document.removeEventListener('click', outsideClickListener);
        document.addEventListener('click', outsideClickListener);
    }

    createToggleButtons(wrapperSelector, btnSelector, toggleAreaSelector, toggleClasses) {
        const self = this;
        let wrappers = document.querySelectorAll(wrapperSelector);
        wrappers.forEach(wrapper => {
            const toggleButton = wrapper.querySelector(btnSelector);
            if (toggleButton) {
                const toggleArea = wrapper.querySelector(toggleAreaSelector);
                if (toggleArea) {
                    toggleButton.addEventListener('click', function () {
                        const wasExpanded = toggleButton.classList.contains(toggleClasses.expanded);
                        if (wasExpanded) {
                            self.collapse(toggleButton, toggleArea);
                        } else {
                            self.expand(toggleButton, toggleArea);
                        }
                    });
                }
            }
        });
    }

    expand(toggleButton, toggleArea) {
        toggleButton.setAttribute('aria-expanded', 'true');
        toggleButton.classList.add(this.toggleClasses.expanded);
        toggleButton.classList.remove(this.toggleClasses.collapsed);
        toggleArea.classList.add(this.toggleClasses.expanded);
        toggleArea.classList.remove(this.toggleClasses.collapsed);
        if (this.hideOnOutsideClick) {
            const self = this;
            setTimeout(function () {
                self.setupHideOnOutsideClick(toggleButton, toggleArea);
            });
        }
    }

    collapse(toggleButton, toggleArea) {
        toggleButton.setAttribute('aria-expanded', 'false');
        toggleButton.classList.remove(this.toggleClasses.expanded);
        toggleButton.classList.add(this.toggleClasses.collapsed);
        toggleArea.classList.remove(this.toggleClasses.expanded);
        toggleArea.classList.add(this.toggleClasses.collapsed);
    }
}

module.exports = ToggleButton;
